// These fields are not supported in the old issue create modal
export const UNSUPPORTED_FIELD_TYPES = [
	'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype',
];
export const ERROR_ICON_TEST_ID = 'issue-create.common.ui.fields.incompatible-field.error-button';
export const MESSAGE_CONTAINER_TEST_ID =
	'issue-create.common.ui.fields.incompatible-field.message-container';
